import { render, staticRenderFns } from "./DestinationDetails.vue?vue&type=template&id=66683130&scoped=true&"
import script from "./DestinationDetails.vue?vue&type=script&lang=js&"
export * from "./DestinationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DestinationDetails.vue?vue&type=style&index=0&id=66683130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66683130",
  null
  
)

export default component.exports